import React, { useState, useCallback } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import ImageCropper from "./index";
import "./ProfileImageCropModal.css";

const ProfileImageCropModal = ({
  isOpen,
  imgSrc,
  savedCrop,
  onCancel,
  onApply,
}) => {
  const [cropData, setCropData] = useState(null);
  const [croppedImage, setCroppedImage] = useState(null);

  const handleCropChange = useCallback((crop, dataUrl) => {
    setCropData(crop);
    setCroppedImage(dataUrl);
  }, []);

  const handleApply = () => {
    if (croppedImage && cropData) {
      onApply(cropData, croppedImage);
    }
  };

  const handleClosed = () => {
    setCropData(null);
    setCroppedImage(null);
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={onCancel}
      className="profile-crop-modal"
      centered
      onClosed={handleClosed}
    >
      <ModalHeader toggle={onCancel}>Crop Image</ModalHeader>
      <ModalBody>
        {imgSrc && (
          <ImageCropper
            key={imgSrc}
            variant="profile"
            imgSrc={imgSrc}
            savedCrop={savedCrop}
            onChange={handleCropChange}
          />
        )}
      </ModalBody>
      <ModalFooter className="profile-crop-modal__footer">
        <button
          type="button"
          className="btn btn-outline profile-crop-modal__btn-cancel"
          onClick={onCancel}
        >
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-app profile-crop-modal__btn-apply"
          onClick={handleApply}
          disabled={!croppedImage}
        >
          Apply
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default ProfileImageCropModal;
